import type { FC } from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Button } from 'react-native-paper';

import { ArrowForwardIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

const styles = StyleSheet.create({
  buttonContent: { flexDirection: 'row-reverse', gap: 8 },
  buttonLabel: { margin: 4, marginRight: 4, marginLeft: 8 }
});

export const MeinOrtShowAllButton: FC<{
  onPress: () => void;
  testID?: string;
}> = memo(({ onPress, testID }) => {
  const { t } = useTranslation(LocalizationNameSpace.MY_PLACE, {
    keyPrefix: 'screens.myPlace.alle'
  });

  return (
    <Button
      compact
      mode="text"
      testID={testID}
      onPress={onPress}
      icon={({ color, size }) => (
        <ArrowForwardIcon width={size} height={size} fill={color} />
      )}
      contentStyle={styles.buttonContent}
      labelStyle={styles.buttonLabel}
    >
      {t('all')}
    </Button>
  );
});
MeinOrtShowAllButton.displayName = 'MeinOrtShowAllButton';
